export function financial(x) {
  return Number.parseFloat(x).toFixed(2);
}